import {
  VIEW_JSON_FILE,
  VIEW_JSON_FILE_FAILURE,
  VIEW_JSON_FILE_SUCCESS,
} from "../types";

export const viewJsonFile = (payload) => ({
  type: VIEW_JSON_FILE,
  payload
});

export const viewJsonFileSuccess = (payload) => ({
  type: VIEW_JSON_FILE_SUCCESS,
  payload,
});

export const viewJsonFileFailure = (payload) => ({
  type: VIEW_JSON_FILE_FAILURE,
  payload,
});
